import React, { useEffect, useState } from "react";
import Navbar from "../../components/common/Navbar";
import BannerSection from "../../components/common/BannerSection";
import ContactBanner from "../../assets/images/banner-bg1.jpg";
import { axiosInstance, config } from "../config";
import { notification } from "antd";
import { Link, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import axios from "axios";
import Loader from "../../components/common/Loader";
import moment from "moment";

const BlogDetails = () => {
  useEffect(() => window.scrollTo(0, 0), [])
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [blogs, setBlogs] = useState([]);
  const [blog_details, setBlogDetails] = useState([]);
  const { slug } = useParams();

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await axios.get("https://earth.cubextechnology.com/api/blogs");
        setBlogs(response.data.blogs);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);
  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const response = await axios.get(
          `https://earth.cubextechnology.com/api/blog_details/${slug}`
        );
        setBlogDetails(response.data.blog);
      } catch (err) {
        setError("Failed to fetch blog details.");
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [slug]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("details", message);
    try {
      const res = await axiosInstance.post("blogenquiry", formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      });
      setLoading(false);
      if (res.data.message == "Message Succesfully sent...") {
        notification.open({
          message: "Message Received Successfully ",
          description: (
            <div style={{ color: "#000", zIndex: 999 }}>
              Your message has been sent! 🎉 Thank you for reaching out to us.
              We’re excited to connect and will get back to you shortly. Stay
              tuned!
            </div>
          ),
          showProgress: true,
          className: "custom-notification",
        });
        setName("");
        setEmail("");
        setMessage("");
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };
  const [blog_name, setBlogName] = useState("");
  const [blog_email, setBlogEmail] = useState("");
  const [blog_subject, setBlogSubject] = useState("");
  const [blog_message, setBlogMessage] = useState("");
  const blogSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();
    formData.append("blog_name", blog_name);
    formData.append("blog_email", blog_email);
    formData.append("blog_subject", blog_subject);
    formData.append("blog_details", blog_message);
    try {
      const res = await axiosInstance.post("blogcomment", formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      });
      setLoading(false);
      if (res.data.message == "Message Succesfully sent...") {
        notification.open({
          message: "Message Received Successfully ",
          description: (
            <div style={{ color: "#000", zIndex: 999 }}>
              Your message has been sent! 🎉 Thank you for reaching out to us. Stay
              tuned!
            </div>
          ),
          showProgress: true,
          className: "custom-notification",
        });
        setBlogName("");
        setBlogEmail("");
        setBlogSubject("");
        setBlogMessage("");
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };
  return (
    <div>
      {isLoading && <Loader />}
      <Helmet><title>Diving Deep into Web Trends and Techniques</title></Helmet>
      <Navbar inner={true} />
      <BannerSection
        Banner={ContactBanner}
        title={"Blog Details"}
        subtitle={"Success is that it is a process"}
      />
      <div className="site-content mt-5 pt-5">
        <section className="ellipse-bottom">
          <div className="container">
            <div className="row justify-content-left">
              <div className="col-lg-8 col-md-12">
                <div className="blog-details-desc">
                  <div className="post-content-header">
                    <div className="blog-post-img">
                      <img
                        className="img-fluid radius-10"
                        src={`${config.imageUrl}/blogs/${blog_details.main_image}`} alt={blog_details.title}
                      />
                    </div>
                    <div className="article-content">
                      <div className="entry-meta">
                        <ul>
                          <li
                            className="post-meta-category"
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                            &nbsp;{moment(blog_details.created_at).format("MMMM D, YYYY")}
                          </li>
                          - <li className="post-meta-date">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                            &nbsp;{blog_details?.admin_name}</li>
                        </ul>
                      </div>
                      <h2 className="post-title">{blog_details?.title}</h2>
                    </div>
                    <div className="blog-post-content">
                      <div className="post-content-body">
                        <p dangerouslySetInnerHTML={{ __html: blog_details.content }}></p>
                      </div>
                    </div>
                  </div>
                  <div className="widget widget_categories post-content-body">
                    <h3 className="widget-title">Leave a Reply</h3>
                    <form onSubmit={blogSubmit}>
                      <div className="row">
                        <div className="col-lg-6 col-md-6">
                          <div className="form-group">
                            <input
                              type="text"
                              name="blog_name"
                              placeholder="Name"
                              className="form-control"
                              aria-label="Name"
                              value={blog_name}
                              onChange={(e) => setBlogName(e.target.value)}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <div className="form-group">
                            <input
                              type="text"
                              name="blog_email"
                              placeholder="Email Address"
                              className="form-control"
                              aria-label="Email"
                              value={blog_email}
                              onChange={(e) => setBlogEmail(e.target.value)}
                              required
                            />
                          </div>
                        </div> <div className="col-lg-12 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              name="blog_subject"
                              placeholder="Subject"
                              className="form-control"
                              aria-label="Subject"
                              value={blog_subject}
                              onChange={(e) => setBlogSubject(e.target.value)}
                              required
                            />
                          </div>
                        </div>

                        <div className="col-lg-12 col-md-12">
                          <div className="form-group">
                            <textarea
                              name="text"
                              cols="30"
                              rows="5"
                              placeholder="Message"
                              className="form-control"
                              value={blog_message}
                              onChange={(e) => setBlogMessage(e.target.value)}
                              required
                            ></textarea>
                          </div>
                        </div>
                        <div className="col-lg-12 col-sm-12">
                          <button type="submit" className="btn btn-primary submit-btn">
                            Send Message
                            {isLoading && (
                              <span
                                className="spinner-border spinner-border-sm ml-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                            )}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-12">
                <div className="widget-area" id="secondary">
                  <div className="widget widget_startp_posts_thumb">
                    <h3 className="widget-title">Popular Posts</h3>
                    {blogs?.slice(0, 5).map((obj, i) => (
                      <article className="item">
                        <Link to={`${config.appUrl}blog-detail/${obj.slug}`} className="thumb">
                          <img src={`${config.imageUrl}/blogs/${obj.main_image}`} alt={obj.title} className="fullimage cover" role="img" />
                        </Link>
                        <div className="info">
                          <time> {moment(obj.created_at).format("MMMM D, YYYY")}</time>
                          <h4 className="title usmall">
                            <Link to={`${config.appUrl}blog-detail/${obj.slug}`}>{obj.title}</Link>
                          </h4>
                        </div>
                        <div className="clear"></div>
                      </article>
                    ))
                    }
                  </div>
                  <div className="widget widget_categories">
                    <h3 className="widget-title">Get In Touch</h3>
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-lg-12 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              name="name"
                              placeholder="Name"
                              className="form-control"
                              aria-label="Name"
                              value={name}
                              onChange={(e) => setName(e.target.value)}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-lg-12 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              name="email"
                              placeholder="Email Address"
                              className="form-control"
                              aria-label="Email"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-lg-12 col-md-12">
                          <div className="form-group">
                            <textarea
                              name="text"
                              cols="30"
                              rows="5"
                              placeholder="Message"
                              className="form-control"
                              value={message}
                              onChange={(e) => setMessage(e.target.value)}
                              required
                            ></textarea>
                          </div>
                        </div>
                        <div className="col-lg-12 col-sm-12">
                          <button type="submit" className="btn btn-primary submit-btn">
                            Send Message
                            {isLoading && (
                              <span
                                className="spinner-border spinner-border-sm ml-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                            )}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default BlogDetails;
